import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ typography, palette, spacing, variables}) => ({
  boxWrapper: {
    position: 'relative',
    fontFamily: typography.fontFamily,
    fontSize: 0,
    whiteSpace: 'nowrap',
    padding: `${variables?.spacingNone} ${variables?.spacingNone} ${variables?.spacingNone} ${variables?.spacingC}`,
    '& .marker': {
      transform: 'translateX(-50%)',
      zIndex: -1,
      position: 'relative'
    },
    '&.z-layer-top':{
      zIndex:999
    },
    '&.z-layer-toppest':{
      zIndex:'1000 !important'
    },
    '&.courier-assigned': {
      padding: `${variables?.spacingB} ${variables?.spacingNone} ${variables?.spacingNone} ${variables?.spacingC}`,
      '&.view-lg': {
        padding: `${variables?.spacingC} ${variables?.spacingNone} ${variables?.spacingNone} ${variables?.spacingC} `,
      },
    },

    '&:hover': {
      cursor: 'pointer',
    },
  },
  '@keyframes bounce': {
    '0%, 20%, 50%, 80%, 100%': { transform: 'translateY(0)' },
    '40%': { transform: 'translateY(-30px)' },
    '60%': { transform: 'translateY(-15px)' },
  },
  justify_center:{
    display:'flex',
    justifyContent:'center',
    align:'center'
  },
  sequenceNumber:{
    backgroundColor:palette?.jet?.containerDark,
    color:`${palette.jet?.containerDefault}`,
    borderRadius: variables?.radiusRoundedE,
    width: '16px',
    float: 'left',
    marginRight: variables?.spacingA,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight:'bold'
  },
  box: {
    backgroundColor:`${palette.jet?.containerDefault}`,
    width:'120px',
    height:'53px',
    boxShadow:variables?.elevation04,
    border:`1px solid ${palette.jet?.containerDefault}`,
    borderRadius:variables?.radiusRoundedA,
    position: 'relative',
    left: 'calc(-50% - 3px)',
    top: '-8px',
    paddingLeft:variables?.spacingB,
    paddingRight:variables?.spacingB,
    paddingTop:variables?.spacingA,
    paddingBottom:variables?.spacingA,
    '&::before': {
        width: '7px',
        height: '7px',
        content: "''",
        position: 'absolute',
        transform: 'rotate(45deg)',
        background: `${palette.jet?.containerDefault}`,
        boxShadow: 'none',
        boxSizing: 'border-box',
        borderRight: 'inherit',
        borderBottom: 'inherit',
        left:'50%',
        bottom: '-4px'
    },
    '& .jetFontIcon':{
      color:palette?.jet?.supportBrand01,
      paddingRight:variables?.spacingA
    },
    '& .courier-name': {
      position: 'absolute',
      top: 0,
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    '&.order-status-UNASSIGNED':{
      '& .jetFontIcon':{
        color: palette?.jet?.supportError
      },
      '& .separator':{
        borderTop:`1px solid ${palette?.jet?.supportError}`,
      },
    },
    '&.order-status-DELIVERED':{
      '& .jetFontIcon':{
        color: palette?.jet?.supportPositive
      },
      '& .separator':{
        borderTop:`1px solid ${palette?.jet?.supportPositive}`,
      },
    },
    '&.order-status-ASSIGNED':{
      '& .jetFontIcon':{
        color: palette?.jet?.interactiveBrand
      },
      '& .separator':{
        borderTop:`1px solid ${palette?.jet?.interactiveBrand}`,
      },
    },
    '&.order-status-IN_DELIVERY':{
      '& .jetFontIcon':{
        color: palette?.jet?.supportInfo
      },
      '& .separator':{
        borderTop:`1px solid ${palette?.jet?.supportInfo}`,
      },
    },
    '& .separator':{
      borderTop:`1px solid ${palette?.jet?.borderDefault}`,
      borderBottom:'0px',
      marginTop:variables?.spacingA,
      marginBottom:variables?.spacingA,
      height:'1px'
    },
    '&.order-hovered': {
      zIndex: 1001,
      transition: 'border 500ms ease-out',
      backgroundColor:palette?.jet?.contentDefault,
      border:`1px solid ${palette?.jet?.contentDefault}`,
      color:`${palette.jet?.containerDefault} !important`,
      animation: `$bounce 2s ease infinite`,
      '&::before': {
        background: palette?.jet?.contentDefault,
      },
      '& .jetFontIcon':{
        color:`${palette.jet?.containerDefault} !important`
      },
      '& .separator':{
        borderTop:`1px solid ${palette.jet?.containerDefault} !important`,
      }
    },
    '.courier-assigned > &': {
      padding:`${variables?.spacingA} ${variables?.spacingA} ${variables?.spacingA}`,
    },
    '.courier-assigned.view-lg > &': {
      padding:`${variables?.spacingC} ${variables?.spacingA} ${variables?.spacingA}`,
    },
    '.view-lg > &': {
      '& .courier-name': {
        fontSize: '1rem',
        lineHeight: 1.5,
      },
      '& h5': {
        fontSize: typography.body1.fontSize,
        fontWeight: 700,
        lineHeight: 1.28571429,
      },
      '& .status': {
        fontSize: typography.body1.fontSize,
        lineHeight: 1.28571429,
      },
    },
  },
  boxMarkerText: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign:'center'
  },
  customerName:{
    textOverflow:'ellipsis',
    display:'block',
    whiteSpace:'nowrap',
    overflow:'hidden'
  }
}));

export default styles;
